import(/* webpackMode: "eager", webpackExports: ["DashboardLayoutSidebar"] */ "/app/src/components/layout/dashboard-layout-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/app/src/components/ui/sidebar.tsx");
